import { gql } from '@urql/core';

export const PROCUREMENT_PLAN_REPORT_LIST_QUERY = gql`
  query ProcurementPlanReportList {
    procurementPlanReports {
      nodes {
        id
        year
        status
        createdBy
        updatedBy
        createdAt
        updatedAt
        totalAmount
        currency
        approvalType
        templateId
        flowCaseId
        flowCaseNumber
        submittedBy
        submissionDate
        isOutdated
        plans {
          procurementPlanId
          teamId
          teamName
          totalAmount
          itemCount
          capturedAt
        }
      }
    }
  }
`;

export const PROCUREMENT_PLAN_REPORT_ONE_QUERY = gql`
  query procurementPlanReport($id: String!) {
    procurementPlanReport(id: $id) {
      id
      year
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      totalAmount
      currency
      approvalType
      templateId
      flowCaseId
        flowCaseNumber
      submittedBy
      submissionDate
      isOutdated
      externalWorkflow
      steps {
        order
        roleSlug
        stepName
      }
      approval {
        approvedBy
        approvedOn
        remarks
      }
      plans {
        procurementPlanId
        teamId
        teamName
        planSubmissionDate
        totalAmount
        itemCount
        capturedAt
        items
      }
  }
}
`;

export const PROCUREMENT_PLAN_REPORT_CREATE_MUTATION = gql`
  mutation CreateProcurementPlanReport($input: CreateProcurementPlanReportInput!) {
    createProcurementPlanReport(input: $input) {
      id
      year
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      totalAmount
      currency
      approvalType
      templateId
      flowCaseId
        flowCaseNumber
      submittedBy
      submissionDate
      isOutdated
      plans {
        procurementPlanId
        teamId
        teamName
        planSubmissionDate
        totalAmount
        itemCount
        capturedAt
        items
      }
    }
  }
`;

export const PROCUREMENT_PLAN_REPORT_UPDATE_MUTATION = gql`
  mutation UpdateProcurementPlanReport($id: String!, $input: UpdateProcurementPlanReportInput!) {
    updateProcurementPlanReport(id: $id, input: $input) {
      id
      year
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      totalAmount
      currency
      approvalType
      templateId
      flowCaseId
        flowCaseNumber
      submittedBy
      submissionDate
      isOutdated
      plans {
        procurementPlanId
        teamId
        teamName
        planSubmissionDate
        totalAmount
        itemCount
        capturedAt
        items
      }
    }
  }
`;

export const PROCUREMENT_PLAN_REPORT_DELETE_MUTATION = gql`
  mutation DeleteProcurementPlanReport($id: String!) {
    deleteProcurementPlanReport(id: $id) {
      id
    }
  }
`;

export const PROCUREMENT_PLAN_REPORT_SUBMIT_MUTATION = gql`
  mutation SubmitProcurementPlanReport($input: SubmitProcurementPlanReportInput!) {
    submitProcurementPlanReport(input: $input) {
      report {
        id
        year
        status
        createdBy
        updatedBy
        createdAt
        updatedAt
        totalAmount
        currency
        approvalType
        templateId
        flowCaseId
        flowCaseNumber
        submittedBy
        submissionDate
        isOutdated
        plans {
          procurementPlanId
          teamId
          teamName
          planSubmissionDate
          totalAmount
          itemCount
          capturedAt
          items
        }
      }
      wasSubmitted
      message
    }
  }
`;

export const PROCUREMENT_PLAN_REPORT_GENERATE_MUTATION = gql`
  mutation GenerateProcurementPlanReport($year: Int!, $teamId: String) {
    generateProcurementPlanReport(year: $year, teamId: $teamId) {
      id
      year
      status
      createdBy
      updatedBy
      createdAt
      updatedAt
      totalAmount
      currency
      approvalType
      templateId
      flowCaseId
        flowCaseNumber
      submittedBy
      submissionDate
      isOutdated
      plans {
        procurementPlanId
        teamId
        teamName
        totalAmount
        itemCount
        capturedAt
        items {
          productName
          productDescription
          productCategory
          quantity
          unitPrice
          totalPrice
        }
      }
  }
}
`;

export const CHECK_APPROVED_PLANS_QUERY = gql`
  query CheckApprovedPlans($year: Int!) {
    procurementPlans(filter: { status: { eq: "APPROVED" }, fiscalYear: { eq: $year } }) {
      nodes {
        id
        teamId
        teamName
        status
        fiscalYear
        totalAmount
      }
    }
    teams {
      nodes {
        id
        name
      }
    }
  }
`;